import { ReportColumnPersonalizationFlags } from '../columnUtils.types';
import {
  PurchaseOrderLineItemReportTableGroupingColumnId,
  PurchaseOrderLineItemReportTableValueColumnId,
} from './purchaseOrderLineItemColumnUtils.types';

export const PURCHASE_ORDER_LINE_ITEM_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseOrderDate]: {
    isDateTime: true,
  },
  [PurchaseOrderLineItemReportTableGroupingColumnId.PurchaseCancellationDate]: {
    isDateTime: true,
  },
  [PurchaseOrderLineItemReportTableValueColumnId.Tax]: {
    isNumeric: true,
    isCurrency: true,
  },
  [PurchaseOrderLineItemReportTableValueColumnId.Shipping]: {
    isNumeric: true,
    isCurrency: true,
  },
  [PurchaseOrderLineItemReportTableValueColumnId.CreditCardFee]: {
    isNumeric: true,
    isCurrency: true,
  },
  [PurchaseOrderLineItemReportTableValueColumnId.BulkDiscount]: {
    isNumeric: true,
    isCurrency: true,
  },
  [PurchaseOrderLineItemReportTableValueColumnId.Cancelled]: {
    isNumeric: true,
    isCurrency: true,
  },
};
